dmx.Component('bs5-collapse', {

  initialData: {
    collapsed: true
  },

  attributes: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggle () {
      this._instance.toggle();
    },

    show () {
      this._instance.show();
    },

    hide () {
      this._instance.hide();
    }
  },

  events: {
    show: Event,
    shown: Event,
    hide: Event,
    hidden: Event
  },

  init (node) {
    node.classList.add('collapse');

    this._showHandler = this._showHandler.bind(this);
    this._shownHandler = this._shownHandler.bind(this);
    this._hideHandler = this._hideHandler.bind(this);
    this._hiddenHandler = this._hiddenHandler.bind(this);

    node.addEventListener('show.bs.collapse', this._showHandler);
    node.addEventListener('shown.bs.collapse', this._shownHandler);
    node.addEventListener('hide.bs.collapse', this._hideHandler);
    node.addEventListener('hidden.bs.collapse', this._hiddenHandler);

    const options = { toggle: false };

    if (node.hasAttribute('data-bs-parent')) {
      options.parent = node.getAttribute('data-bs-parent');
    }

    if (this.props.show) {
      node.classList.add('show');
    }

    this._instance = new bootstrap.Collapse(node, options);
    //this._instance[this.props.show ? 'show' : 'hide']();
  },

  destroy () {
    this.$node.removeEventListener('show.bs.collapse', this._showHandler);
    this.$node.removeEventListener('shown.bs.collapse', this._shownHandler);
    this.$node.removeEventListener('hide.bs.collapse', this._hideHandler);
    this.$node.removeEventListener('hidden.bs.collapse', this._hiddenHandler);

    this._instance.dispose();
  },

  performUpdate (updatedProps) {
    if (updatedProps.has('show')) {
      this._instance[this.props.show ? 'show' : 'hide']();
      this.set('collapsed', !this.props.show);
    }
  },

  _showHandler (event) {
    event.stopPropagation();
    this.dispatchEvent('show');
  },

  _shownHandler (event) {
    event.stopPropagation();
    this.set('collapsed', false);
    this.dispatchEvent('shown');
  },

  _hideHandler (event) {
    event.stopPropagation();
    this.dispatchEvent('hide');
  },

  _hiddenHandler (event) {
    event.stopPropagation();
    this.set('collapsed', true);
    this.dispatchEvent('hidden');
  },

});
